import { StyleSheet } from 'react-native';

const SubscribeBannerImage = ({ style }) => {
  const oneX = require('./subscribe-banner.jpg');
  const twoX = require('./subscribe-banner@2x.jpg');
  return (
    <img
      src={twoX}
      alt=""
      style={{ ...StyleSheet.flatten(style), objectFit: 'cover' }}
      srcSet={`${oneX}, ${twoX} 2x`}
    />
  );
};

export { SubscribeBannerImage };
